module.exports = __webpack_public_path__ + "img/violet_085.893a0c6e.png";